import Vue from 'vue'
import Router from 'vue-router'
import SignUp from '@/components/signup/SignUp'
import SignIn from '@/components/signin/SignIn'
import Reservation from '@/components/reservation/Reservation'
import Dashboard from '@/components/dashboard/Dashboard'
import Admin from '@/components/admin/Admin'
import Resources from '@/components/admin/Resources'
import Users from '@/components/admin/Users'
import Schedule from '@/components/admin/Schedule'
import ResourcesSchedule from '@/components/admin/ResourcesSchedule'
import EditResourcesSchedule from '@/components/admin/EditResourcesSchedule'
import ResourcesTypes from '@/components/admin/ResourcesTypes'
import Profile from '@/components/profile/Profile'
import OwnReservations from '@/components/profile/Reservations'
import store from '@/store/store'

Vue.use(Router)

const authGuard = (to, from, next) => {
  if (store.state.token) {
    next()
  } else {
    next('/')
  }
}

const authAdmin = (to, from, next) => {
  if (store.state.token && store.state.user.rol) {
    next()
  } else if (store.state.token) {
    next('/dashboard')
  } else {
    next('/')
  }
}

const isLogged = (to, from, next) => {
  if (store.state.token) {
    next('/dashboard')
  } else {
    next('/signin')
  }
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      beforeEnter: isLogged
    },
    {
      path: '/signin',
      name: 'signin',
      component: SignIn
    },
    {
      path: '/signup',
      name: 'signup',
      component: SignUp
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      beforeEnter: authGuard
    },
    {
      path: '/admin/reservations',
      name: 'reservations',
      component: Admin,
      beforeEnter: authAdmin
    },
    {
      path: '/admin/resources',
      name: 'resources',
      component: Resources,
      beforeEnter: authAdmin
    },
    {
      path: '/admin/schedule',
      name: 'schedule',
      component: Schedule,
      beforeEnter: authAdmin
    },
    {
      path: '/admin/users',
      name: 'users',
      component: Users,
      beforeEnter: authAdmin
    },
    {
      path: '/admin/resourcesschedule',
      name: 'resourcesschedule',
      component: ResourcesSchedule,
      beforeEnter: authAdmin
    },
    {
      path: '/admin/editresourcesschedule/:id:name',
      name: 'editresourcesschedule',
      component: EditResourcesSchedule,
      beforeEnter: authAdmin
    },
    {
      path: '/admin/resourcestypes',
      name: 'resourcestypes',
      component: ResourcesTypes,
      beforeEnter: authAdmin
    },
    {
      path: '/reservation/:id:name',
      name: 'reservation',
      component: Reservation,
      beforeEnter: authGuard
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      beforeEnter: authGuard
    },
    {
      path: '/profile/reservations',
      name: 'ownreservations',
      component: OwnReservations,
      beforeEnter: authGuard
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js